import { categoryHelper } from '~/lib/category/helper';
import type { CategorySchema } from '~/types/schema';
import { ContentTypes } from '~/types/adamTypes';

import ViewDiscipline from '~/components/categories/view/ViewDiscipline.vue';
import ViewChapter from '~/components/categories/view/ViewChapter.vue';
import ViewSubChapter from '~/components/categories/view/ViewSubChapter.vue';
import ViewCategories from '~/components/categories/view/ViewCategories.vue';
import ViewSingleDiscipline from '~/components/categories/view/ViewSingleDiscipline.vue';

import ViewPostsPdfThumbnails from '~/components/categories/view/ViewPostsPdfThumbnails.vue';
export const useCategoryRouterView = (category: CategorySchema): Component => {
  const helper = categoryHelper();

  const getView = (): Component => {
    switch (category.contentType) {
      case ContentTypes.SubChapter:
        return ViewSubChapter;

      case ContentTypes.CourseAndQuiz:
      case ContentTypes.Exam:
      case ContentTypes.Testing:
      case ContentTypes.Training:
        return ViewCategories;
      case ContentTypes.SuperDiscipline:
      case ContentTypes.InterDisciplineFocusOn:
      case ContentTypes.Discipline:
      case ContentTypes.SubDiscipline:
      case ContentTypes.DisciplineSection:
      case ContentTypes.InterDiscipline:
      case ContentTypes.DisciplineSubSection:
        // case ContentTypes.SubChapter:
        if (
          helper.hasCategories(category) &&
          helper.hasOnlyCategoryWithTypes(category, [
            ContentTypes.SubDiscipline,
            ContentTypes.Extra,
            ContentTypes.SubChapter,
            ContentTypes.Chapter,
          ])
        ) {
          return ViewDiscipline;
        } else if (
          helper.hasCategories(category) &&
          helper.hasOneOfThisCategory(category, [
            ContentTypes.DisciplineSection,
            ContentTypes.SubDiscipline,
            ContentTypes.Extra,
            ContentTypes.Discipline,
          ])
        ) {
          return ViewCategories;
        } else if (helper.hasDifferentCategories(category)) {
          return ViewDiscipline;
        } else if (
          helper.hasOnlyCategoryWithType(category, ContentTypes.Annals) ||
          helper.hasOnlyCategoryWithType(category, ContentTypes.Chapter) ||
          helper.hasOnlyCategoryWithType(category, ContentTypes.Essential)
        ) {
          return ViewSingleDiscipline;
        } else if (
          helper.hasOnlyPostsWithType(category, PostTypes.ContentPDF)
        ) {
          // normaly not used because previous actions already open a modal
          return ViewPostsPdfThumbnails;
        } else {
          return ViewDiscipline;
        }
      case ContentTypes.Practice:
        if (helper.hasExercises(category)) {
          return ViewChapter;
        } else {
          return ViewSingleDiscipline;
        }
      case ContentTypes.Extra:
        return ViewSingleDiscipline;
      case ContentTypes.Chapter:
        return ViewChapter;
      // From Christophe sources
      case ContentTypes.VideoRecorder:
      case ContentTypes.VideoRecorderResult:
        // TODO Oral training

        // case ContentTypes.Annals:
        //   // TODO Anals
        //   return 'Annals';
        // case ContentTypes.Essential:
        //   // TODO Essential
        //   return 'Essential';
        // case ContentTypes.globalThis.esult:
        //   // TODO globalThis.esult
        //   return 'globalThis.esult';
        // case ContentTypes.Adventure:
        //   // TODO Adventures
        //   return 'Adventure';

        return resolveComponent('div') as Component;
    }
  };
  const view = getView();

  return view;
};
